import { formatNumber } from "src/utils/numbers";

const UNLIMITED_LABEL = "Unlimited";

const isUnlimited = (n: number) => n < 0;

export const formatCompactTokens = (n: number) =>
  formatNumber(n, { notation: "compact", maximumFractionDigits: 1 });

export const formatLimit = (n: number) =>
  isUnlimited(n) ? UNLIMITED_LABEL : formatCompactTokens(n);

export const formatCount = (n: number) =>
  isUnlimited(n) ? UNLIMITED_LABEL : formatNumber(n);
